// Module-scoped endpoint paths for order placement, detail, and history.

export const ORDER_ENDPOINTS = {
  ORDERS: '/api/orders',
  ORDER_DETAIL: '/api/orders/{orderId}',
  CANCEL_ORDER: '/api/orders/{orderId}/cancel',
  ORDER_HISTORY: '/api/orders/history',
  ORDER_HISTORY_FILTERS: '/api/orders/history/filters',
  CALCULATE_FEES: '/api/orders/calculate-fees',
} as const
